import styled from 'styled-components';
import { forDesktop, forTablet } from '@westwing/ui-kit/breakPoints';

export const MobileOnly = styled.div`
    display: block;
    width: 100%;
    height: 100%;

    ${forTablet`
        display: none;
    `}
`;

export const FromTablet = styled.div`
    display: none;

    ${forTablet`
        display: block;
        width: 100%;
        height: 100%;
    `}
`;

export const DesktopOnly = styled.div`
    display: none;

    ${forDesktop`
        display: block;
        width: 100%;
        height: 100%;
    `}
`;

const Display = {
    MobileOnly,
    FromTablet,
    DesktopOnly,
};

export default Display;
